export default __webpack_public_path__ + "static/media/Tarifas_ES.60eacf2b.png";